/** 與 roles.role_name 對齊的顯示文案（API 未帶名稱時的後備） */
const ACCOUNT_ROLE_LABELS = {
  system_admin: '系統管理員',
  system_user: '系統使用者',
  platform_admin: '平台管理員',
  platform_user: '平台使用者',
  client_owner: '客戶管理員',
  client_staff: '員工',
};

export function getAccountRoleLabel(role, roleName) {
  if (roleName) {
    return roleName;
  }
  if (!role) {
    return '-';
  }
  return ACCOUNT_ROLE_LABELS[role] || role;
}
